export default function Cartao({ titulo, subtitulo, icone: Icone, children, e2e, destaque = false }) {
  return (
    <section className={`bg-card rounded-2xl border p-5 sm:p-6 ${destaque ? "border-primary/40 ring-1 ring-primary/10" : ""}`} data-e2e={e2e}>
      <div className="flex items-start gap-2.5 mb-4">
        <div className="w-9 h-9 rounded-lg bg-primary/10 flex items-center justify-center shrink-0"><Icone className="w-5 h-5 text-primary" /></div>
        <div className="min-w-0">
          <h2 className="text-base font-bold leading-tight">{titulo}</h2>
          {subtitulo ? <p className="text-xs text-muted-foreground mt-0.5">{subtitulo}</p> : null}
        </div>
      </div>
      {children}
    </section>
  );
}
